import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { getStorage, connectStorageEmulator } from 'firebase/storage'

// Firebase configuration from environment variables
// These values are loaded from .env.local file (not committed to git)
export const firebaseConfig = {
  apiKey: (import.meta as any).env.VITE_FIREBASE_API_KEY,
  authDomain: (import.meta as any).env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: (import.meta as any).env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: (import.meta as any).env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: (import.meta as any).env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: (import.meta as any).env.VITE_FIREBASE_APP_ID,
  measurementId: (import.meta as any).env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase services
export const auth = getAuth(app)
export const db = getFirestore(app)
export const functions = getFunctions(app, 'europe-west2')
export const storage = getStorage(app)

// Firebase emulator configuration for local development
// Set VITE_USE_FIREBASE_EMULATOR=true to use emulators, otherwise uses production
export const useEmulator = (import.meta as any).env.VITE_USE_FIREBASE_EMULATOR === 'true'

export const emulatorConfig = {
  auth: {
    host: 'localhost',
    port: 9099
  },
  firestore: {
    host: 'localhost',
    port: 8080
  },
  functions: {
    host: 'localhost',
    port: 5001
  },
  storage: {
    host: 'localhost',
    port: 9199
  }
}

// Connect to emulators if enabled
if (useEmulator) {
  try {
    // Connect to Auth emulator
    connectAuthEmulator(auth, `http://${emulatorConfig.auth.host}:${emulatorConfig.auth.port}`, {
      disableWarnings: true
    })
    
    // Connect to Firestore emulator
    connectFirestoreEmulator(db, emulatorConfig.firestore.host, emulatorConfig.firestore.port)
    
    // Connect to Functions emulator
    connectFunctionsEmulator(functions, emulatorConfig.functions.host, emulatorConfig.functions.port)
    
    // Connect to Storage emulator
    connectStorageEmulator(storage, emulatorConfig.storage.host, emulatorConfig.storage.port)
    
    console.log('🔧 Connected to Firebase emulators')
  } catch (error) {
    // Emulators might already be connected
    console.log('Firebase emulators already connected or failed to connect:', error)
  }
} else {
  console.log('🌐 Using production Firebase services')
}

export default app 